export default __webpack_public_path__ + "static/media/triangle.b1c84f24.svg";